import "../stringUtils-DdV7wDb8.mjs";
import { deepCamelizeKeys } from "../objectUtils-Dgpg2pm-.mjs";
import { isEmpty, isNullish, omitBy } from "remeda";
import Axios from "axios";
import queryString from "query-string";
import { AuthService } from "@core/auth-services";

//#region src/api/helpers.ts
function parseData({ passMetadata = false }) {
	return ({ data }) => {
		const hasDataWrapper = Object.prototype.hasOwnProperty.call(data, "data");
		const hasMetadataWrapper = Object.prototype.hasOwnProperty.call(data, "meta");
		if (hasDataWrapper) {
			if (passMetadata && hasMetadataWrapper) return {
				data: deepCamelizeKeys(data.data),
				metadata: deepCamelizeKeys(data.meta)
			};
			return deepCamelizeKeys(data.data);
		}
		return deepCamelizeKeys(data);
	};
}
function parseError(error) {
	const { name, message, response } = error;
	const { data, status = 500 } = response || {};
	const isNetworkError = name === "Error" && message === "Network Error";
	return Promise.reject({
		name,
		data,
		status,
		message,
		isNetworkError
	});
}

//#endregion
//#region src/api/api.ts
var Api = class {
	_ssr;
	_apiEndpoint;
	_skipVersion;
	_authService;
	_requiredAuth;
	constructor({ baseUrl, storage, ssr = false, requiredAuth, skipVersion = false }) {
		this._ssr = ssr;
		this._authService = AuthService;
		this._skipVersion = skipVersion;
		this._apiEndpoint = baseUrl || "";
		this._requiredAuth = requiredAuth;
		this._authService.config({ storage });
	}
	static create(params) {
		return new this(params);
	}
	async _options({ requiredAuth, headers = {} }) {
		let options = {};
		if (requiredAuth) {
			const authToken = await this._authService.token();
			if (authToken) options = {
				...options,
				headers: { Authorization: `Bearer ${authToken}` }
			};
		}
		options.headers = {
			...options.headers,
			...headers
		};
		return options;
	}
	async _request({ data, params, signal, headers, endpoint, version = 1, method = "get", onUploadProgress, isExternal = false, requiredAuth = true, skipVersion = false, passMetadata = false }) {
		if (typeof endpoint !== "string") endpoint = queryString.stringifyUrl({
			url: endpoint.url,
			query: omitBy(endpoint.query || {}, (val) => isNullish(val))
		}, { arrayFormat: "bracket" });
		let url = endpoint.replace(/^\//, "");
		if (!isExternal) url = [
			this._apiEndpoint,
			!(this._skipVersion || skipVersion) ? `v${version}` : "",
			url
		].filter((s) => !!s).join("/");
		const opts = await this._options({
			headers,
			requiredAuth: isNullish(this._requiredAuth) ? requiredAuth : this._requiredAuth
		});
		const promise = Axios.request({
			...omitBy({
				url,
				data,
				params,
				method
			}, (value) => !(!this._ssr && value instanceof FormData) && isEmpty(value)),
			...opts,
			signal,
			onUploadProgress
		}).then(parseData({ passMetadata })).catch(parseError);
		return promise;
	}
	get(options) {
		return this._request({
			method: "get",
			...options
		});
	}
	post(options) {
		return this._request({
			method: "post",
			...options
		});
	}
	put(options) {
		return this._request({
			method: "put",
			...options
		});
	}
	delete(options) {
		return this._request({
			method: "delete",
			...options
		});
	}
};

//#endregion
export { Api };